export type FullscreenElementLike = {
  requestFullscreen?: () => Promise<void>;
};

export type FullscreenDocumentLike = {
  fullscreenElement?: unknown;
  documentElement?: FullscreenElementLike;
  exitFullscreen?: () => Promise<void>;
};

export async function toggleFullscreen(documentLike: FullscreenDocumentLike | undefined = typeof document === "undefined" ? undefined : document): Promise<"entered" | "exited" | "unavailable"> {
  if (!documentLike?.documentElement) return "unavailable";
  if (documentLike.fullscreenElement) {
    if (!documentLike.exitFullscreen) return "unavailable";
    await documentLike.exitFullscreen();
    return "exited";
  }
  if (!documentLike.documentElement.requestFullscreen) return "unavailable";
  await documentLike.documentElement.requestFullscreen();
  return "entered";
}
